<template>
  <div class="app-container">
    <HeaderComp @menu-click="handleMenuClick" data-v></HeaderComp>
    <BannerComp id="home" data-v></BannerComp>
    <ProductComp id="product" data-v></ProductComp>
    <ProfileComp id="company" data-v></ProfileComp>
    <SupportComp id="support" data-v></SupportComp>
    <BusinessComp data-v></BusinessComp>
    <ContactComp id="contact" data-v></ContactComp>
    <QrcodeComp data-v></QrcodeComp>
    <FooterComp data-v></FooterComp>
  </div>
</template>

<script>
import HeaderComp from './components/HeaderComp.vue'
import BannerComp from './components/BannerComp.vue'
import ProductComp from './components/ProductComp.vue'
import ProfileComp from './components/ProfileComp.vue'
import SupportComp from './components/SupportComp.vue'
import BusinessComp from './components/BusinessComp.vue'
import ContactComp from './components/ContactComp.vue'
import QrcodeComp from './components/QrcodeComp.vue'
import FooterComp from './components/FooterComp.vue'

export default {
  components: {
    HeaderComp,
    BannerComp,
    ProductComp,
    ProfileComp,
    SupportComp,
    BusinessComp,
    ContactComp,
    QrcodeComp,
    FooterComp
  },
  name: 'App',
  mounted() {
    this.initScrollObserver();
  },
  methods: {
    handleMenuClick(id) {
      const el = document.getElementById(id);
      if (el) {
        const offset = 80;
        const topPos = el.offsetTop - offset;
        window.scrollTo({
          top: topPos,
          behavior: 'smooth'
        });
      }
    },
    initScrollObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate__animated', 'animate__fadeIn', 'animate__slower', 'vue-lazy')
          }
        })
      }, { 
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      document.querySelectorAll('[data-v]').forEach(el => {
        observer.observe(el);
      });
    }
  }
}
</script>

<style lang="scss">
@import 'animate.css';

body {
  margin: 0;
  padding: 0;
}

#app {
  background: #FFF;
  width: 100%;

  .app-container {
    padding-top: 80px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: linear-gradient(89.99999deg, #E6EEF8 0%, #F5F7FA 100%), rgba(0, 0, 0, 0.00);
  }
}

@media (max-width: 768px) {
  #app {
    .app-container {
      padding-top: 80px;
    }
  }
}
</style>